export const featureList = [
	{
		id: 1,
		feature: 'Transações',
		description: 'Controle despesas, receitas e transferências.',
		icon: 'table'
	},
	{
		id: 2,
		feature: 'Cartão de crédito',
		description: 'Controle as despesas e o limite do seu cartão.',
		icon: 'credit-card'
	},
	{
		id: 3,
		feature: 'Objetivos',
		description: 'Separe e organize seu dinheiro para atingir um objetivo.',
		icon: 'bullseye'
	},
	{
		id: 4,
		feature: 'Importe Automático',
		description: 'Importe as informações de gastos e receitas automaticamente da sua conta do NuBank.',
		icon: 'wand-sparkles'
	},
]